const HTTP_STATUS_UNPROCESSABLE_ENTITY = 422

export const parseErrorMessage = (error) => {
  // Parse validation errors
  if (error?.response?.status === HTTP_STATUS_UNPROCESSABLE_ENTITY) {
    const messages = []
    Object.keys(error.response.data.validationErrors).forEach((property) => {
      const errors = error.response.data.validationErrors[property]
      errors.forEach((er) => {
        messages.push(er)
      })
    })

    return messages[0]
  }

  return undefined
}
